import React from "react";
import "./logout_Confirm_Modal.css";
import { Button, Modal } from "react-bootstrap";

function LogoutConfirmModal(props) {
  return (
    <div className="Delete_Modal_sec">
      <Modal
        className="Delete_Modal"
        show={props.show}
        onHide={props.onHide}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Logout</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="text-center mb-4">Are you sure you want to logout?</p>

          <div className="text-center">
            <Button variant="secondary" className="me-3" onClick={props.onHide}>
              No
            </Button>

            <Button variant="danger" onClick={props.handleLogout}>
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default LogoutConfirmModal;
